import { lazy } from "react";
import { Navigate } from "react-router-dom";

import AuthGuard from "./auth/AuthGuard";
import { authRoles } from "./auth/authRoles";

import Loadable from "./components/Loadable";
import MatxLayout from "./components/MatxLayout/MatxLayout";
import MatxLayoutOther from "./components/MatxLayout/MatxLayoutOther";

import aiRoutes from "app/views/ai/routes/Routes";
import gstRoutes from "app/views/gst/routes/Routes";
import dtRoutes from "app/views/dt/routes/Routes";
import stRoutes from "app/views/st/routes/Routes";
import clRoutes from "app/views/cl/routes/Routes";
import othersRoutes from "app/views/others/routes/Routes";

// SESSION PAGES
const NotFound = Loadable(lazy(() => import("app/views/sessions/NotFound")));
const JwtLogin = Loadable(lazy(() => import("app/views/sessions/JwtLogin")));
const JwtLogout = Loadable(lazy(() => import("app/views/sessions/JwtLogout")));
const JwtRegister = Loadable(lazy(() => import("app/views/sessions/JwtRegister")));
const ForgotPassword = Loadable(lazy(() => import("app/views/sessions/ForgotPassword")));
const Analytics = Loadable(lazy(() => import("app/views/dashboard/App")));
const About = Loadable(lazy(() => import("app/views/others/about/App")));
const UserSetting = Loadable(lazy(() => import("app/views/others/settings/App")));

const routes = [
  {
    element: (
      <AuthGuard>
        <MatxLayoutOther />
      </AuthGuard>
    ),
    children: [
      ...aiRoutes,
    ]
  },
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      ...gstRoutes,
      ...dtRoutes,
      ...stRoutes,
      ...clRoutes,
      ...othersRoutes,
      // dashboard route
      { path: "/dashboard", element: <Analytics />, auth: authRoles.guest },
      { path: "/user-setting", element: <UserSetting />, auth: authRoles.guest },
      { path: "/whats-new/:id", element: <Analytics />, auth: authRoles.editor },
      { path: "/about", element: <About />, auth: authRoles.guest},
      { path: "/session/signin", element: <JwtLogin /> },
      { path: "/session/logout", element: <JwtLogout /> },
      { path: "/session/signup", element: <JwtRegister /> },
      { path: "/session/forgot-password", element: <ForgotPassword /> },
      { path: "/session/404", element: <NotFound /> },
      { path: "/", element: <Navigate to="dashboard" /> },
      { path: "*", element: <NotFound /> }
    ]
  },

];

export default routes;
